import { useUser } from "@components/user-context";
import { type FetchMediaPlanData_me_mmm_mediaPlanData_mediaPlanList } from "@north-beam/nb-client-side/nb-api-graphql-generated";
import { VERIFY_ADDITIONAL_DATA } from "@north-beam/nb-common";
import { useMMMClient } from "@pages/mmm/hooks/use-mmm-client";
import { PrimaryButton } from "@shared/buttons";

import { useUpdateMediaPlanDraftStep } from "../../hooks/use-update-media-plan-draft-step";
import { DEPRECATED_WIZARD_STEPS as WIZARD_STEPS } from "../consts";

import { MediaPlanVerifyButton } from "./media-plan-verify-button";

interface Props {
  currentIndex: number;
  selectedMediaPlan: FetchMediaPlanData_me_mmm_mediaPlanData_mediaPlanList;
}

export const AdditionalDataStep = ({
  currentIndex,
  selectedMediaPlan,
}: Props) => {
  const { verify, unverify, isUpdateMediaPlanDraftStepLoading } =
    useUpdateMediaPlanDraftStep({
      draftStep: VERIFY_ADDITIONAL_DATA,
      selectedMediaPlan,
    });
  const isDraft = selectedMediaPlan.state === "draft";
  const isVerified =
    selectedMediaPlan.step_tracker[VERIFY_ADDITIONAL_DATA].verified;

  const _verify = async () => verify([]);

  const { user } = useUser();
  const [mmmClient] = useMMMClient();

  return (
    <div>
      <div className="mb-4">
        <div className="text-lg font-semibold">
          {WIZARD_STEPS[currentIndex].title}
        </div>
        {WIZARD_STEPS[currentIndex].description && isDraft && (
          <div className="text-sm text-interstellar-1">
            {WIZARD_STEPS[currentIndex].description}
          </div>
        )}
      </div>
      <div className="mb-6">
        <div className="text-xs font-bold pb-2">CUSTOM SPEND CHANNELS</div>
        <PrimaryButton
          onClick={() =>
            window.open(
              user.pathFromRoot("/settings/data-spreadsheets"),
              "_blank",
              "noopener,noreferrer",
            )
          }
        >
          CLICK HERE TO VERIFY CUSTOM SPEND CHANNELS
        </PrimaryButton>
      </div>
      <div>
        <div className="text-xs font-bold pb-2">MMM+ DATA INPUTS</div>
        <PrimaryButton
          onClick={() =>
            window.open(
              mmmClient?.input_google_sheet_url,
              "_blank",
              "noopener,noreferrer",
            )
          }
        >
          CLICK HERE TO VERIFY MMM+ DATA INPUTS
        </PrimaryButton>
      </div>
      <div className="mt-4 flex justify-end">
        <MediaPlanVerifyButton
          verify={_verify}
          unverify={unverify}
          isVerified={isVerified}
          isLoading={isUpdateMediaPlanDraftStepLoading}
        />
      </div>
    </div>
  );
};
